export default __webpack_public_path__ + "static/media/gallery-6.7c01e68d.jpg";